import React from "react";
import { Message } from "./Message";
import { Message as MessageType } from "../../types/types";

export function MessageSwitch({
    messages,
    currentMessageIndex,
    currentPartIndex,
    conversationName,
    handleLinkClick,
    getLocalization,
}: {
    messages: MessageType[];
    currentMessageIndex: number;
    currentPartIndex: number;
    conversationName: string;
    handleLinkClick: (cta: InboxCTA) => void;
    getLocalization: (id: string) => string;
}) {
    const message = messages[currentMessageIndex];
    if (!message) return null;

    const part = message.body[currentPartIndex];
    if (!part) return null;

    const previousPart =
        messages[currentMessageIndex]?.body[currentPartIndex - 1];

    switch (part.type) {
        case "text": {
            return (
                <Message
                    key={`${currentMessageIndex}-${currentPartIndex}`}
                    from={message.from}
                    linkPart={
                        previousPart?.type === "link" ? previousPart : undefined
                    }
                    handleLinkClick={handleLinkClick}
                    getLocalization={getLocalization}
                >
                    {part.content}
                </Message>
            );
        }
        case "guestText": {
            return (
                <Message
                    key={`${currentMessageIndex}-${currentPartIndex}`}
                    from="guest"
                    icon={conversationName}
                    linkPart={
                        previousPart?.type === "link" ? previousPart : undefined
                    }
                    handleLinkClick={handleLinkClick}
                    getLocalization={getLocalization}
                >
                    {part.content}
                </Message>
            );
        }
        default:
            return null;
    }
}
